import React from "react";
import { NavLink } from "react-router-dom";

import "./index.scss";

const UserProfileItem = props => {
  const { id, page, pathname, name, icon, secondaryIcon, clickHanlder, isDescriptionOnly } = props;

  return (
    <>
      {!isDescriptionOnly ? (
        <NavLink
          id={`menu_item_${id}`}
          name={name || id}
          to={pathname}
          state={{ page: id }}
          className="dropdownNavItem descriptionText"
          onClick={event => clickHanlder(event, name)}
        >
          <img src={icon} alt={name} height="32px" width="32px" />
          <span>{page}</span>
          {secondaryIcon && <img className="lauch-icon" src={secondaryIcon} alt="launch" />}
        </NavLink>
      ) : (
        <div className="smalldescriptionText padding-left-10 pb-1">
          <span>{page}</span>
        </div>
      )}
    </>
  );
};

export default UserProfileItem;
